var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 359,
    viewBox: "0 0 181 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.912 -1.9624L306 85.1773L0.358488 358.551L196.912 -1.9624Z",
    fill: "url(#paint0_linear_147_7884)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_7884",
    x1: 198.541,
    y1: 107.037,
    x2: -107.92,
    y2: 489.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001149",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086EC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLight);
export default __webpack_public_path__ + "static/media/right-light.6cecb53edbafae880254d198fcb5ef2e.svg";
export { ForwardRef as ReactComponent };